import { css } from 'lit';

export const baseLogItemViewStyles = css`

  /*=== HOST ===*/

  :host {
    background: linear-gradient(
      180deg,
      var(--theme-color-primary-4, var(--yellow-2)) 0,
      var(--view-gradient-end-color) 200px
    );
    --view-gradient-end-color: var(--gray-1);

    --theme-color-primary-0: color-mix(in hsl, var(--theme-color-primary) 10%, white);
    --theme-color-primary-1: color-mix(in hsl, var(--theme-color-primary) 15%, white);
    --theme-color-primary-2: color-mix(in hsl, var(--theme-color-primary) 20%, white);
    --theme-color-primary-3: color-mix(in hsl, var(--theme-color-primary) 50%, white);
    --theme-color-primary-4: color-mix(in hsl, var(--theme-color-primary) 80%, white);
    --theme-color-primary-5: color-mix(in hsl, var(--theme-color-primary) 100%, white);
    --theme-color-primary-6: color-mix(in hsl, var(--theme-color-primary) 80%, black);
    --theme-color-primary-7: color-mix(in hsl, var(--theme-color-primary) 50%, black);
    --theme-color-primary-8: color-mix(in hsl, var(--theme-color-primary) 30%, black);
    --theme-color-primary-9: color-mix(in hsl, var(--theme-color-primary) 15%, black);

    --theme-color-secondary-0: color-mix(in hsl, var(--theme-color-secondary) 10%, white);
    --theme-color-secondary-1: color-mix(in hsl, var(--theme-color-secondary) 15%, white);
    --theme-color-secondary-2: color-mix(in hsl, var(--theme-color-secondary) 20%, white);
    --theme-color-secondary-3: color-mix(in hsl, var(--theme-color-secondary) 50%, white);
    --theme-color-secondary-4: color-mix(in hsl, var(--theme-color-secondary) 80%, white);
    --theme-color-secondary-5: color-mix(in hsl, var(--theme-color-secondary) 100%, white);
    --theme-color-secondary-6: color-mix(in hsl, var(--theme-color-secondary) 80%, black);
    --theme-color-secondary-7: color-mix(in hsl, var(--theme-color-secondary) 50%, black);
    --theme-color-secondary-8: color-mix(in hsl, var(--theme-color-secondary) 30%, black);
    --theme-color-secondary-9: color-mix(in hsl, var(--theme-color-secondary) 15%, black);
  }

  view-content {
    padding-top: 7rem;
  }

  /*=== LOG ITEM CONTENT ===*/

  log-item-content {
    display: block;
    background: white;
    box-shadow: var(--sl-shadow-small);
    padding: 2rem;
    
    margin: 0 -2rem;
    border-radius: 0;
  }
  @media(min-width: 650px) {
    log-item-content {
      margin: 0;
      border-radius: 12px;
    }
  }
  @media(min-width: 1000px) {
    log-item-content {
      padding: 2.5rem;
    }
  }

  log-item-content h1.main-header {
    margin: 0;
  }

  sl-tag.log-item-status::part(base) {
    background-color: color-mix(in hsl, var(--theme-color-secondary) 15%, transparent);
    color: var(--theme-color-secondary-6);
    border-color: var(--theme-color-secondary-4);
  }

  .log-item-status {
    float: right;
    margin: 0 0 1rem 1rem;
  }

  ul#authors-panel {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    list-style: none;
    padding: 0;
    margin: 2rem 0;
  }

  ul#authors-panel li {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  #details-wrapper {
    display: flex;
    gap: 2rem;

    padding: 1rem 0;
    margin: 2rem 0;
    
    border-top: 1px solid var(--gray-2);
    border-bottom: 1px solid var(--gray-2);
    color: var(--gray-6);
    font-weight: 300;

    --link-color-default: var(--gray-6);
    --link-color-visited: var(--gray-6);
    --link-color-focus: var(--gray-9);
    --link-font-weight-default: 300;
    --link-text-decoration-default: none;
    --link-text-decoration-focus: none;
  }

  ul#details-panel {
    flex: 1 1 auto;

    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem 2rem;
    margin: 0;
    padding: 0;

    list-style: none;
  }

  ul#details-panel li {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
    padding: 0;
  }

  #details-actions {
    flex: 0 0 auto;

    display: flex;
    gap: 0.5rem;
    align-items: flex-start;
  }

  #details-actions a {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  log-item-content sl-divider.full-width {
    margin-left: -2rem;
    margin-right: -2rem;
  }

  div.top-line {
    display: flex;
    position: relative;
    flex-direction: column;
    gap: 1rem;
    padding-left: 2.5rem;
  }

  div.top-line sl-icon {
    position: absolute;;
    top: 0.1rem;
    left: 0;
    font-size: 1.5rem;
    color: var(--theme-color-primary);
  }
  
  div.top-line p.subtitle {
    margin: 0;
    font-weight: 200;
    font-style: italic;
  }

  /*=== LOG ITEM FORM ===*/

  log-item-content fieldset-panel {
    background: color-mix(in hsl, var(--theme-color-secondary) 1.5%, transparent);
  }

  log-item-content p.subtitle.hero:first-child {
    margin-top: 0;
  }

  log-item-content .label-on-left {
    --label-width: 6.5rem;
  }

  #publishDateNotes {
    margin-top: 0;
    padding: 0.25rem 0 0.25rem 1rem;
    border-left: 6px solid var(--theme-color-secondary-3);
  }
  @media(min-width: 650px) {
    #publishDateNotes {
      margin-left: 7.5rem;
    }
  }

`;
